import React from 'react';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import { connect } from 'react-redux';
import renderHTML from 'react-render-html'
import axios from 'axios';
import Loader from "../../../components/ui/Loader/Loader";
import { toast } from 'react-toastify';
import tapIcon from "../../../services/TapIcon";
import Ax from "../../../components/hoc/Ax";
import HttpAPICall from '../../../services/HttpAPICall';
import TapApiUrls from '../../../services/TapApiUrls';
import { DisplayListPagination, DisplaySearchCriteria, PeriodSelectionWithCustom } from '../../../components/TapUi';
import { Modal } from 'bootstrap';
import TapSelect from '../../../components/ui/TapSelect';
import AppBaseComponent from '../../../components/AppBaseComponent';
import { Helmet } from 'react-helmet';
import Status from '../../../components/ui/Status';
import InputResourceSearch from '../../includes/ui/InputResourceSearch';
import swal from "sweetalert";


class ReleasesList extends AppBaseComponent {

    constructor(props) {
        super(props);
        

        this.state                           =     {
            
            minimizeTable              :       false,
            listing_loading            :       false,
            listing_tbl_page           :       1,
            release_listing               :       [],
            listingMeta                :       null,
            totalListingCount          :       0,
            releaseDetail               :       null
        };
    }

    componentDidMount() {
        this.initalizeComponent(this.props); 
       
      this.loadListingTblData(1);
     
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.permissions !== this.props.permissions){
            this.initalizeComponent(nextProps);
        }
    }

    initalizeComponent      =       (pr)            =>      {
        this.setState({
            permissions     :       pr.permissions && pr.permissions.length > 0 ? pr.permissions : [],
        })
    }

  
     loadListingTblData                 =   (page = 1)  =>         {
        this.setState({listing_loading: true, listing_tbl_page: page});
        let params                      =   {page:page,per_page:50};
        HttpAPICall.withAthorization('GET',  process.env.REACT_APP_SERVER_PATH + '/backoffice/release', this.props.access_token, params, {}, (resp) => {
            let respData            =       resp.data;
           
            this.setState({
                release_listing      :       respData.data,
                listingMeta         :       respData.meta,
                totalListingCount   :       respData.meta.total,
        });
        }).then(() => this.setState({listing_loading: false}));
    }

    addReleaseFormInit          =       ()      =>      {
        this.props.history.push('/release_add')
    }

    viewDetailInit          =       (id)      =>      {
        if (this.props.permissions.includes('app-release-view')) {
            this.setState({
                minimizeTable: true
            })
            this.getReleaseDetails(id)
        }else{
            toast.error('You dont have permission for this action')
        }
    }

    getReleaseDetails                 =   (id)  =>         {
        this.setState({detail_loading:true})
        HttpAPICall.withAthorization('GET',  process.env.REACT_APP_SERVER_PATH + '/backoffice/release/' + id, this.props.access_token, {}, {}, (resp) => {
            let respData            =       resp.data;
          this.setState({releaseDetail : respData.data})
        }).then(() => this.setState({detail_loading: false}));
    }

    closeViewDetails        =       ()      =>      {
        this.setState({minimizeTable:false})
    }

    editReleaseInit        =       ()      =>      {
        this.props.history.push({ pathname: `/release_add`, state: { editReleaseData : this.state.releaseDetail } });
    }

    deleteReleaseInit      =       ()        =>      {
        swal({
            title: "Delete",
            text: "This action cannot be reversed, Are you sure you want to proceed?",
            icon: "warning",
            dangerMode: true,
            buttons: ["No", "Yes"],
        }).then(willDelete => {
            if (willDelete) {
            
                HttpAPICall.withAthorization('DELETE', process.env.REACT_APP_SERVER_PATH + '/backoffice/release/' + this.state?.releaseDetail?.id, this.props.access_token, {},{} ,(response) => {
                    toast.success(response.data.msg, {position: toast.POSITION.TOP_RIGHT});
                    this.setState({minimizeTable : false});
                    this.loadListingTblData(1);
                }).then(() => { });
            }
        });
    }

    changeStatusInit        =       ()      =>      {
        let frmData = {
            id      :   this?.state?.releaseDetail?.id,
            status  :   this?.state?.releaseDetail?.status == 1  ? 2 : 1
        }

        swal({
            title: "Change Status",
            text: "This action cannot be reversed, Are you sure you want to proceed?",
            icon: "warning",
            // dangerMode: true,
            buttons: ["No", "Yes"],
        })
            .then(willChangeStatus => {
                if (willChangeStatus) {
                    HttpAPICall.withAthorization('PUT', process.env.REACT_APP_SERVER_PATH + '/backoffice/release/' + this.state.releaseDetail?.id, this.props.access_token, {} ,{...frmData},(response) => {
                        toast.success(response.data.msg, {position: toast.POSITION.TOP_RIGHT});
                        this.loadListingTblData(1);
                        this.getReleaseDetails(this.state?.releaseDetail?.id)
                    }).then(() => {

                    });
                }
            });
    }

    changeReleaseSupportInit        =       ()      =>      {
        let frmData = {
            id      :   this?.state?.releaseDetail?.id,
            is_supported  :   this?.state?.releaseDetail?.is_supported == "Y"  ? "N" : "Y"
        }

        swal({
            title: "Change Release Support",
            text: "This action cannot be reversed, Are you sure you want to proceed?",
            icon: "warning",
            // dangerMode: true,
            buttons: ["No", "Yes"],
        })
            .then(willChangeStatus => {
                if (willChangeStatus) {
                    HttpAPICall.withAthorization('PUT', process.env.REACT_APP_SERVER_PATH + '/backoffice/release/' + this.state.releaseDetail?.id, this.props.access_token, {} ,{...frmData},(response) => {
                        toast.success(response.data.msg, {position: toast.POSITION.TOP_RIGHT});
                        this.getReleaseDetails(this.state?.releaseDetail?.id)
                    }).then(() => {

                    });
                }
            });
    }
   
    releaseListJsx            =       ()      =>    {
       
        return (<Ax><div className="page_title row m0">
            <div className={this.state.minimizeTable ? "col-3" : "col-12"}>
                <h3>New Releases List</h3>
                <div className="text-end mt15">
                    {(!this.state.minimizeTable) ?
                        <Ax>
                         {this.props.permissions.includes('app-release-add') && <button type="button"  className="btn btn-primary" onClick={() => this.addReleaseFormInit()}>New</button>}

                        </Ax> : null}
                </div>
            </div>
            {
                this.state.minimizeTable
                    ? (
                        <div className="col-9 tap_border_left">
                            <h3>Release : {this.state?.releaseDetail?.title} </h3>
                            <div className="text-end mt15">
                                {this.props.permissions.includes('app-release-edit') && <button type="button" className="btn btn-secondary" onClick={this.editReleaseInit}>
                                    Edit
                                </button>}

                                <span className="dropdown">
                                    <button type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn btn-secondary">
                                        <tapIcon.imageIcon icon={tapIcon.ActionIcon} className="img-fluid" alt="item-action" />
                                    </button>
                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                        {this.props.permissions.includes('app-release-delete') && <li>
                                            <a role="button" onClick={() => this.deleteReleaseInit()}
                                                className={'dropdown-item'}
                                                style={{ "pointerEvents": "all" }}>Delete</a></li>}

                                        {this.props.permissions.includes('app-release-change') && <li>
                                            <a className="dropdown-item" href="#"
                                                onClick={() => this.changeStatusInit()}>
                                                {this.state.releaseDetail && this.state.releaseDetail.status == 1 ? "Deactivate" : "Activate"}
                                            </a></li>}
                                        {this.props.permissions.includes('app-release-change') && <li>
                                            <a className="dropdown-item" href="#"
                                                onClick={() => this.changeReleaseSupportInit()}>
                                                Change Release Support
                                            </a></li>}
                                    </ul>

                                </span>
                                <button type="button" className="btn btn-secondary" onClick={this.closeViewDetails}>
                                    <tapIcon.imageIcon icon={tapIcon.CloseIcon} className="img-fluid" alt="item-close" />
                                </button>
                            </div>
                        </div>
                    )
                    : null
            }
        </div>
            <div className="container-fluid pl5">
                <div className="page_containt row">
                    <div className={['pageTbl', this.state.minimizeTable ? 'col-3' : 'col-12'].join(' ')} >{this.releaseListingJsx()}</div>
                    {this.state.minimizeTable ? <div className="col-9 pr4 pl4"><div className="bg-white p-2" style={{ height: "100%" }}>{this.releaseDetailJsx()}</div></div> : null}
                </div>
            </div>
        </Ax>);
    }

    releaseListingJsx            =   ()   =>   {
        return (<Ax>
           
            <table className="table table-bordered table-fixed  bg-white table-sm">
                <thead className="table-secondary" >
                    <tr className='text-center'>
                        {this.state.minimizeTable ? <th scope="col" style={{ width: "15%" }}>Title</th>
                            : <Ax>
                                <th scope="col" style={{ width: "5%" }}>S.No</th>
                                <th scope="col" style={{ width: "15%" }}>Date of Upgrade</th>
                                <th scope="col" style={{ width: "25%" }}>Title</th>
                                <th scope="col" style={{ width: "15%" }}>Platform</th>
                                <th scope="col" style={{ width: "10%" }}>Can be Published</th>
                                <th scope="col" style={{ width: "10%" }}>Supported</th>
                                <th scope="col" style={{ width: "10%" }}>Status</th>
                                <th scope="col" className="text-center" style={{ width: "5%" }}>Action</th>
                            </Ax>}

                    </tr>
                </thead>
                <tbody>
                    {this.state.listing_loading
                        ? (<tr><td colSpan="8"><Loader /></td></tr>)
                        : (this.state.release_listing && this.state.release_listing.length > 0
                            ? (this.state.release_listing.map((item, index) => {
                                return (<tr key={index} >
                                    {this.state.minimizeTable ? <td className='link-primary cursor_pointer' onClick={() => this.viewDetailInit(item.id)}>{item.title ? item.title : "-"}</td>
                                        : <Ax>
                                            <td className='text-center'>{this.state.listingMeta ? this.state.listingMeta.from + index : index}</td>
                                            <td className='text-center'>{item.upgrade_time_display ? item.upgrade_time_display : ""}</td>
                                            <td className='link-primary cursor_pointer' onClick={() => this.viewDetailInit(item.id)}>{item.title ? item.title : "-"}</td>
                                            <td className='text-capitalize text-center'>{item.platform ? item.platform : ""}</td>
                                            <td className='text-center'>{item.is_supported && item.is_supported == 'Y' ? "Yes" : "No"}</td>
                                            <td className='text-center'>{item.can_published && item.can_published == 'Y' ? "Yes" : "No"}</td>
                                            <td className='text-center'>{item.status && item.status == 1 ? "Active" : "InActive"}</td>
                                            <td className='text-center'>
                                                <tapIcon.imageIcon icon={tapIcon.ListActionIcon} alt="action-icon" className="img-fluid px-3" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false" />
                                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                    <li><a className="dropdown-item" onClick={() => this.viewDetailInit(item.id)} role="button">View</a></li>
                                                </ul>
                                            </td>
                                        </Ax>}

                                </tr>)
                            }))
                            : (<tr><td colSpan="8" className="text-center">No Records</td></tr>))
                    }

                </tbody>
            </table>
            <DisplayListPagination
                meta={this.state.listingMeta}
                onPageChange={(e) => this.loadListingTblData(e.selected + 1)}
            />
        </Ax>)
    }

    releaseDetailJsx                  =       ()      =>      {
        let detail = this.state.releaseDetail ? this.state.releaseDetail : null
        return (<section className="item_view_container bg-white">
            {/* <ul className="nav nav-tabs" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                    <button className="nav-link active" id="details-tab" data-bs-toggle="tab" data-bs-target="#details"
                        type="button" role="tab" aria-controls="details" aria-selected="true">Details
                    </button>

                </li>
               
             
            </ul>
            <div className="tab-content" id="myTabContent">
                <div className="tab-pane  show active" id="details" role="tabpanel" aria-labelledby="details-tab"> */}
                    {this.state.detail_loading ? <div className='text-center'><Loader/></div>
                    : <Ax>
                        {detail && <div className="tab_content_header">
                                <div className="tab_content_wrapper"> <span className="content_heading"> Detail</span></div>
                                <table className="table table-hover table-bordered  table-responsive bg-white my-2 ">
                                    <tbody className='resource_table'>
                                        <tr>
                                            <td style={{ width: "25%" }}>Date of Upgrade</td>
                                            <th>{detail.upgrade_time_display ? detail.upgrade_time_display : ""}</th>
                                        </tr>
                                        <tr>
                                            <td style={{ width: "25%" }}>Title</td>
                                            <th>{detail.title ? detail.title : ""}</th>
                                        </tr>
                                        <tr>
                                            <td style={{ width: "25%" }}>Status</td>
                                            <th>{detail.status && detail.status == 1 ? "Active" : "InActive"}</th>
                                        </tr>
                                        <tr>
                                            <td style={{ width: "25%" }}>Platform</td>
                                            <th className='text-capitalize'>{detail.platform ? detail.platform : ""}</th>
                                        </tr>
                                        <tr>
                                            <td style={{ width: "25%" }}>App Version</td>
                                            <th className='text-capitalize'>{detail.app_version ? detail.app_version : ""}</th>
                                        </tr>
                                      
                                        <tr>
                                            <td style={{ width: "25%" }}>Supported</td>
                                            <th className='text-capitalize'>{detail.is_supported && detail.is_supported == 'Y' ? "Yes" : "No"}</th>
                                        </tr>
                                        <tr>
                                            <td style={{ width: "25%" }}>Description</td>
                                            <th className='text-capitalize'>{detail.description ? renderHTML(detail.description) : "-"}</th>
                                        </tr>
                                        <tr>
                                            <td style={{ width: "25%" }}>Created By</td>
                                            <th className='text-capitalize'>{detail.created_by ? detail.created_by.name : ""}</th>
                                        </tr>
                                        <tr>
                                            <td style={{ width: "25%" }}>Updated By</td>
                                            <th className='text-capitalize'>{detail.updated_by ? detail.updated_by.name : ""}</th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>}
                      </Ax>}
                {/* </div>
                
             
            </div> */}
        </section>);    
    }


    render                              =   ()  =>  {
        return (<ApplicationLayout>
        <Helmet><title>New Releases Listing</title></Helmet>
            {this.releaseListJsx()}
        </ApplicationLayout>);
    }

}


const mapStateToProps = state => {
    return {
        access_token        :   state.auth.access_token,
        permissions         :    state.app.acl_info && state.app.acl_info.permissions && state.app.acl_info.permissions.length > 0 ? state.app.acl_info.permissions : []
    };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(ReleasesList);